import { VText } from '@vake/ui-kit';
import { FC, useEffect } from 'react';
import { Link } from 'react-router-dom';

export const Terms: FC = () => {
    useEffect(() => {
        document.title = 'Privacy Policy';
    }, []);

    return (
        <div className="flex flex-col pt-32 w-[700px] mx-auto gap-10">
            <div className="flex flex-col gap-2">
                <VText variant="H2">Cookie information</VText>
                <VText>
                    Vake.ai utilizes a web analysing tool named{' '}
                    <a className="underline" href="https://www.hotjar.com/" target="_blank" rel="noopener noreferrer">
                        Hotjar
                    </a>
                    . Hotjar makes us capable of understanding user flow on the website, helping us discover
                    opportunities for improvement. Information collected by Hotjar is anonymized. <br />
                    <br />
                    <a
                        className="underline"
                        target="_blank"
                        href="https://www.hotjar.com/legal/policies/privacy/"
                        rel="noopener noreferrer"
                    >
                        Read more about Hotjar and their Privacy Policy
                    </a>
                </VText>
                <VText>
                    <b>What Hotjar collects</b>
                    <ul>
                        <li>Your screen resolution</li>
                        <li>Your browser and operating system</li>
                        <li>Time and date of your visit</li>
                        <li>Approximate geographical location, based on your IP-address</li>
                        <li>Your movements on the site</li>
                        <li>Your clicks on the site</li>
                    </ul>
                </VText>
                <VText>
                    This information helps us improve the flow of information on the site, so that we more efficiently
                    and precisely can communicate our product.
                </VText>
            </div>
            <div className="flex flex-col gap-2">
                <VText variant="H2">Newsletter sign-ups and requests for demo reports</VText>
                <VText>
                    <b>Personal data we collect, and how it's stored</b>
                    <br />
                    Vake lets you sign up for our occasional newsletter. When you do so, your email, name and company
                    name are saved with our CRM tool Clickup. When requesting a demo report product from us, we save
                    your email, name, company name and request content in our CRM tool Clickup. We save this information
                    in order to organize customers, leads, and our interactions. We might use your information to follow
                    up with you regarding how we can add value to you and your company. We treat your data
                    confidentially. It is not disclosed or sold to any third party unless disclosure is required by law,
                    judicial body or government authorities. Your personal data is stored in secure databases.
                    <br />
                    <br />
                    <a
                        className="underline"
                        href="https://clickup.com/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Read more about Clickup's privacy and security policies
                    </a>
                    <br />
                    <br />
                    <b>How long we keep your personal data</b>
                    <br />
                    We retain your personal data for a reasonable amount of time from the date you last expressed
                    interest in our content, products or services (also including having an active newsletter
                    subscription with us).
                    <br />
                    <br />
                    You can unsubscribe from our newsletter directly from one of our previous letters sent to you, or by
                    reaching out to support@vake.ai. You can request the deletion of (and a copy of, as well as
                    correction of) all your personal data from our systems at any time through support@vake.ai.
                </VText>
            </div>
            <div className="gap-2">
                <VText>
                    Read our full privacy statement{' '}
                    <Link to="/privacy-statement" className="underline">
                        here
                    </Link>
                </VText>
            </div>
        </div>
    );
};
